<template>
  <ts-loading-banner :loading="loading">
    <ts-table :columns="columns" :records="resources">
      <template v-slot="{ record }">
        <td>{{ record.branch_name_en }}</td>
        <td>{{ record.name }}</td>
        <td>{{ record.user_name }}</td>
        <td>
          <span
            class="badge badge-primary mr-2"
            v-for="(role, index) in record.roles"
            :key="index"
            >{{ role.name == '*' ? 'Everything' : role.name }}</span
          >
        </td>
        <td class="ts-w-32">
          {{ record.mobile_role ? record.mobile_role.description : null }}
        </td>
        <td class="ts-w-32">
          {{ record.report_to ? record.report_to.name : null }}
        </td>
        <td class="ts-w-32">
          {{ record.sale_position }}
        </td>
        <td class="ts-w-32">
          <span class="badge badge-success" v-if="!record.disable">Yes</span>
          <span class="badge badge-danger" v-else>No</span>
        </td>
        <td class="text-center">
          <a href="#" class="mr-2 text-info" @click.prevent="showModal(record)">
            <i class="fa fa-lock"></i>
          </a>
          <a href="#" class="mr-2 text-primary" @click.prevent="onEdit(record)">
            <i class="fa fa-edit"></i>
          </a>
        </td>
      </template>
    </ts-table>
    <div class="d-flex justify-content-end p-15">
      <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
    </div>
    <a-modal
      v-model="visible_resetpwd"
      :title="$t('user.resetPassword')"
      @ok="handleOk"
      @cancel="closeModal"
      width="20%"
      :okText="$t('save')"
      :confirmLoading="waiting"
      :cancelText="$t('cancel')"
      :maskClosable="false"
    >
      <div class="ts-space-y-3">
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-text-xs">
              {{ $t('user.password') }}
            </label>
            <input
              v-model="model.new_password"
              type="password"
              class="form-control"
              :class="{ 'is-invalid': errors.has('new_password') }"
            />
            <div class="invalid-feedback" v-if="errors.has('new_password')">
              {{ errors.first('new_password') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-text-xs">
              {{ $t('user.confirm') }}
            </label>
            <input
              v-model="model.password_confirmation"
              type="password"
              class="form-control"
              :class="{ 'is-invalid': errors.has('password_confirmation') }"
            />
            <div
              class="invalid-feedback"
              v-if="errors.has('password_confirmation')"
            >
              {{ errors.first('password_confirmation') }}
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </ts-loading-banner>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import { debounce } from 'lodash'
export default {
  name: 'userIndex',
  data() {
    return {
      numeric: 1,
      visible_resetpwd: false,
      loading: false,
      errors: new Errors(),
      waiting: false,
      user_type: 1,
      model: {
        user_id: 0,
        new_password: null,
        password_confirmation: null
      }
    }
  },
  computed: {
    ...mapState('security/user', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.security.user.search
      },
      set(newValue) {
        this.$store.commit('security/user/SET_SEARCH', newValue)
        this.$store.commit('security/user/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('user.branchName') },
        { name: this.$t('user.name') },
        { name: this.$t('user.userName') },
        { name: this.$t('user.roleName') },
        { name: this.$t('user.mobileRole') },
        { name: this.$t('user.reportTo') },
        { name: this.$t('user.salePosition') },
        { name: this.$t('user.active') },
        { name: this.$t('actions'), style: 'width:7%; text-align:center' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('security/user/fetch', attributes)
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onEdit(record) {
      this.$store.commit('security/user/SET_EDIT_DATA', record)
      this.$router.push({ name: 'user-edit', params: { id: record.user_id } })
    },
    showModal(record) {
      this.model.user_id = record.user_id
      this.visible_resetpwd = true
    },
    closeModal() {
      this.model.user_id = 0
      this.model.new_password = null
      this.model.password_confirmation = null
      this.visible_resetpwd = false
      this.errors = new Errors()
    },
    handleOk() {
      this.waiting = true
      this.$store
        .dispatch('security/user/passwordReset', {
          id: this.model.user_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.closeModal()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('security/user/RESET_STATE')
    next()
  }
}
</script>
